import { useEffect, useState } from 'react';

import UploadIcon from '../../../assets/svg/upload.svg';
import { fileReaderToBase64 } from '../../../helpers';
import { fileValidator } from '../../../utils/dragAndDrop';
import DragAndDropContainer from './DragAndDropContainer';
import styles from './UploadFileModal.module.scss';

const UploadFileModal = ({ isImage, filesInfo, setUploadFiles }) => {
  const [error, setError] = useState(false);
  const fileTypes = isImage ? 'image/*' : `application/pdf, text/xml, .doc, .docx, application/msword, 
	application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/*`;

  useEffect(() => {
    if (error) {
      setTimeout(() => setError(false), 3000);
    }
  }, [error]);

  return (
    <div className={styles['upload-file__wrapper']}>
      <DragAndDropContainer
        setUploadFiles={setUploadFiles}
        setError={setError}
        >
        <div className={styles['upload-file__btn']}>
          <label htmlFor="file" className={styles['btn__label']}>
            <img src={UploadIcon} alt="upload" />
            <span className={styles['upload-file__btn__text']}>Carica</span>
            {error && <p className={styles.error}>{error}</p>}
          </label>
          <input
            className={styles['upload-file__input']}
            onChange={async (e) => {
              e.persist();
              const file = Object.values(e.target.files);

              if (file?.length) {
                const { errVal } = fileValidator(file, { fileSizeMBLimit: 60 });

                if (errVal) {
                  setError(errVal);
                  return;
                }

                const base64FileUrl = await fileReaderToBase64(file);

                setUploadFiles({
                  name: file[0].name,
                  url: base64FileUrl
                });
                e.target.value = '';
              }
            }}
            name="file"
            id="file"
            type="file"
            accept={fileTypes}
          />
        </div>
      </DragAndDropContainer>
    </div>
  );
};

export default UploadFileModal;
